import { ToggleButton, Tooltip } from '@fluentui/react-components';
import { bundleIcon, Eye20Filled, Eye20Regular, EyeOff20Filled, EyeOff20Regular } from '@fluentui/react-icons';
import { useTranslation } from 'react-i18next';
import { useIsFeatureEnabled } from '../../api/features/features';
import { useReportSubscriptions } from '../../hooks/useReportSubscriptions';
import { SubscribeToReportEnabled } from '../../utils/FeatureFlags.constants';

const EyeOffBundledButton = bundleIcon(EyeOff20Filled, EyeOff20Regular);
const EyeBundledButton = bundleIcon(Eye20Filled, Eye20Regular);

export const ToggleReportSubscriptionButton = (props: { reportId: number; disabled: boolean }) => {
    const { t } = useTranslation();
    const { data: isSubscribeToReportEnabled } = useIsFeatureEnabled({
        featureFlagName: SubscribeToReportEnabled,
    });
    const { checkIsUserSubscribedToReport, toggleReportSubscription, isLoadingOrUpdatingReportSubscriptions } =
        useReportSubscriptions(isSubscribeToReportEnabled);
    const isUserSubscribedToReport = checkIsUserSubscribedToReport(props.reportId);
    const subscriptionLabel = t(isUserSubscribedToReport ? 'unsubscribeFromReport' : 'subscribeToReport').toString();

    return (
        isSubscribeToReportEnabled && (
            <Tooltip withArrow appearance='inverted' content={subscriptionLabel} relationship='description' positioning='below'>
                <ToggleButton
                    appearance='subtle'
                    size='medium'
                    icon={isUserSubscribedToReport ? <EyeOffBundledButton /> : <EyeBundledButton />}
                    checked={isUserSubscribedToReport}
                    onClick={() => toggleReportSubscription(props.reportId)}
                    aria-label={subscriptionLabel}
                    // we want to keep the button focusable when disabled, so that it retains focus when keyboard users interact with it
                    disabledFocusable={props.disabled || isLoadingOrUpdatingReportSubscriptions}
                />
            </Tooltip>
        )
    );
};
